import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import 'firebase/compat/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
export const analytics = firebase.analytics();

// Prevent errors when a field is undefined
firebase.firestore().settings({ ignoreUndefinedProperties: true });

// Initialize FireStore instance
export const db = app.firestore();

// Initialize Auth instance
export const auth = app.auth();

// setup emulators (note: auth is handled in auth provider)
if (process.env.REACT_APP_ENV === 'development') {
  console.log('configuring emus');
  auth.useEmulator('https://127.0.0.1', 9099);
  db.useEmulator('127.0.0.1', 8080);
}

// helpers to convert FireStore documents to objects with ids
export const snapToDoc = (ref) => ({ id: ref?.id, ...ref?.data?.() });
export const snapsToDoc = (refs) => [...refs].map(snapToDoc);

// date to FireStore timestamp
export const { Timestamp } = firebase.firestore;
export const timestamp = (date) => Timestamp.fromDate(date ?? new Date());
export const { FieldValue } = firebase.firestore;
